module.exports = __webpack_public_path__ + "img/V54.35c3cee8.jpg";